import { useCallback, useRef } from 'react';

export function useCallbackRef<T>(updateRef: (value: T) => void, cleanRef?: (old: T) => void) {
  const ref = useRef<T | null>(null);
  return {
    ref,
    callback: useCallback(
      (node: T) => {
        if (ref.current && cleanRef) {
          cleanRef(ref.current);
        }
        if (node) {
          updateRef(node);
        }
        ref.current = node;
      },
      [updateRef, cleanRef],
    ),
  };
}
